import { getConcepts, getAdminCompanies, getRoles, getProjectTypes, getUserCompanyStatus, updateUserCompanyStatus, getAllCompanyStages, getCompanyProjectDestinies, getCompanyUnarchiveValues, getCompanyDocumentTemplates } from "@/helpers/api/company"

const companyStore = {
  namespaced: true,
  state: {
    selectedCompany: null,
		concepts: [],
		loadingConcepts: false,
		newCompanyConceptModal: false,
		newCompanyConceptModalEditing: null,
		newCompanyModal: false,
		newCompanyModalFirst: false,
		newCompanyModalEditing: null,
		companiesListCount: 0,
		companiesList: [],
		loadingCompaniesList: false,
		loadingRoles: false,
		roles: [],
		newRoleModalEditing: null,
		newRoleModal: false,
		newProjectTypeModalEditing: null,
		newProjectTypeModal: false,
		newDestinyModalEditing: null,
		newDestinyModal: false,
		newCategoryProjectTypeModalEditing: null,
		newCategoryProjectTypeModal: false,
		companiesProjectTypes: [],
		companiesProjectTypesCategories: [],
		editProjectTypesIncludes: false,
		loadingCompaniesProjectTypes: true,
		userCompanyConnectedStatus: null,
		loadingUserCompanyConnectedStatus: true,
		companyContractConfigModal: false,
		companyPlanningStages: [],
		companyPlanningStagesLoading: false,
		companyProjectDestinies: [],
		companyProjectDestiniesCount: 0,
		companyProjectDestiniesLoading: false,
		newUnarchiveValueModalEditing: null,
		newUnarchiveValueModal: false,
		companyUnarchiveValues: [],
		companyUnarchiveValuesCount: 0,
		companyUnarchiveValuesLoading: false,
		companyDocumentTemplates: [],
		loadingCompanyDocumentTemplates: false
  },
  mutations: {
    setSelectedCompany(state, company) {
      state.selectedCompany = company
    },
    setLoadingConcepts(state, loadingConcepts) {
      state.loadingConcepts = loadingConcepts
    },
    setNewRoleModalEditing(state, newRoleModalEditing) {
      state.newRoleModalEditing = newRoleModalEditing
    },
    setNewRoleModal(state, newRoleModal) {
      state.newRoleModal = newRoleModal
    },
    setConcepts(state, concepts) {
      state.concepts = concepts
    },
    setLoadingRoles(state, loadingRoles) {
      state.loadingRoles = loadingRoles
    },
    setRoles(state, roles) {
      state.roles = roles
    },
    setNewCompanyConceptModal(state, newCompanyConceptModal) {
      state.newCompanyConceptModal = newCompanyConceptModal
    },
    setNewCompanyConceptModalEditing(state, newCompanyConceptModalEditing) {
      state.newCompanyConceptModalEditing = newCompanyConceptModalEditing
    },
    setNewCompanyModal(state, newCompanyModal) {
      state.newCompanyModal = newCompanyModal
    },
    setNewCompanyModalFirst(state, newCompanyModalFirst) {
      state.newCompanyModalFirst = newCompanyModalFirst
    },
    setNewCompanyModalEditing(state, newCompanyModalEditing) {
      state.newCompanyModalEditing = newCompanyModalEditing
    },
    setCompaniesList(state, companiesList) {
      state.companiesList = companiesList
    },
    setCompaniesListCount(state, companiesListCount) {
      state.companiesListCount = companiesListCount
    },
    setLoadingCompaniesList(state, loadingCompaniesList) {
      state.loadingCompaniesList = loadingCompaniesList
    },
    setEditProjectTypesIncludes(state, status) {
      state.editProjectTypesIncludes = status
    },
    setCompaniesProjectTypes(state, companiesProjectTypes) {
      state.companiesProjectTypes = companiesProjectTypes
    },
    setCompaniesProjectTypesCategories(state, companiesProjectTypesCategories) {
      state.companiesProjectTypesCategories = companiesProjectTypesCategories
    },
    setLoadingCompaniesProjectTypes(state, loadingCompaniesProjectTypes) {
      state.loadingCompaniesProjectTypes = loadingCompaniesProjectTypes
    },
    setUserCompanyConnectedStatus(state, status) {
      state.userCompanyConnectedStatus = status
    },
    setLoadingUserCompanyConnectedStatus(state, status) {
      state.loadingUserCompanyConnectedStatus = status
    },
    setNewCategoryProjectTypeModalEditing(state, newCategoryProjectTypeModalEditing) {
      state.newCategoryProjectTypeModalEditing = newCategoryProjectTypeModalEditing
    },
    setNewCategoryProjectTypeModal(state, newCategoryProjectTypeModal) {
      state.newCategoryProjectTypeModal = newCategoryProjectTypeModal
    },
    setNewProjectTypeModalEditing(state, newProjectTypeModalEditing) {
      state.newProjectTypeModalEditing = newProjectTypeModalEditing
    },
    setNewProjectTypeModal(state, newProjectTypeModal) {
      state.newProjectTypeModal = newProjectTypeModal
    },
    setNewDestinyModalEditing(state, newDestinyModalEditing) {
      state.newDestinyModalEditing = newDestinyModalEditing
    },
    setNewDestinyModal(state, newDestinyModal) {
      state.newDestinyModal = newDestinyModal
    },
    setCompanyContractConfigModal(state, value) {
      state.companyContractConfigModal = value
    },
		setCompanyPlanningStages(state, states) {
			state.companyPlanningStages = states
		},
		setCompanyPlanningStagesLoading(state, loading) {
			state.companyPlanningStagesLoading = loading
		},
		setCompanyProjectDestinies(state, states) {
			state.companyProjectDestinies = states
		},
		setCompanyProjectDestiniesLoading(state, loading) {
			state.companyProjectDestiniesLoading = loading
		},
		setCompanyProjectDestiniesCount(state, count) {
			state.companyProjectDestiniesCount = count
		},
		setCompanyUnarchiveValueModalEditing(state, newUnarchiveValueModalEditing) {
			state.newUnarchiveValueModalEditing = newUnarchiveValueModalEditing
		},
		setNewUnarchiveValueModal(state, newUnarchiveValueModal) {
			state.newUnarchiveValueModal = newUnarchiveValueModal
		},
		setCompanyUnarchiveValues(state, states) {
			state.companyUnarchiveValues = states
		},
		setCompanyUnarchiveValuesLoading(state, loading) {
			state.companyUnarchiveValuesLoading = loading
		},
		setCompanyUnarchiveValuesCount(state, count) {
			state.companyUnarchiveValuesCount = count
		},
		setCompanyDocumentTemplates(state, templates) {
			state.companyDocumentTemplates = templates
		},
		setLoadingCompanyDocumentTemplates(state, loading) {
			state.loadingCompanyDocumentTemplates = loading
		}
  },
  actions: {
    async getConcepts({ commit }) {
      commit('setLoadingConcepts', true)
      const data = {
        start: 0,
        limit: 30
      }
      const concepts = await getConcepts(data)
      if (concepts.code === 200) {
        commit('setConcepts', concepts.concepts)
      }
      commit('setLoadingConcepts', false)
    },
    async getProjectTypes({ commit }) {
      commit('setLoadingConcepts', true)
      const data = {
        start: 0,
        limit: 30
      }
      const concepts = await getConcepts(data)
      if (concepts.code === 200) {
        commit('setConcepts', concepts.concepts)
      }
      commit('setLoadingConcepts', false)
    },
    async getRoles({ commit }, data) {
      commit('setLoadingRoles', true)
      const dataSend = {
        ...data
      }
      const concepts = await getRoles(dataSend)
      if (concepts.code === 200) {
        commit('setRoles', concepts.roles)
      }
      commit('setLoadingRoles', false)
    },
    async getCompaniesList({ commit }, {search = null, start = 0, limit = 20, deleted = null} = {}) {
      commit('setLoadingCompaniesList', true)
      const data = {
				search,
        start,
        limit,
        deleted
      }
      const companies = await getAdminCompanies(data)
      if (companies.code === 200) {
        commit('setCompaniesList', companies.companies)
        commit('setCompaniesListCount', companies.companies_count)
      }
      commit('setLoadingCompaniesList', false)
    },
    async getCompanyProjectTypes({ commit }) {
      commit('setLoadingCompaniesProjectTypes', true)
      const data = {
        start: 0,
        limit: 30
      }
      const project_types = await getProjectTypes(data)
      if (project_types.code === 200) {
        commit('setCompaniesProjectTypes', project_types.project_types)
				commit('setCompaniesProjectTypesCategories', project_types.project_types_categories)
      }
      commit('setLoadingCompaniesProjectTypes', false)
    },
    async getCompanyProjectDestinies({ commit }, {search = null, start = 0, limit = 20} = {}) {
      commit('setCompanyProjectDestiniesLoading', true)
      const data = {
				search,
        start,
        limit
      }
      const destinies = await getCompanyProjectDestinies(data)
      if (destinies.code === 200) {
        commit('setCompanyProjectDestinies', destinies.destinies)
        commit('setCompanyProjectDestiniesCount', destinies.destinies_count)
      }
      commit('setCompanyProjectDestiniesLoading', false)
    },
    async getCompanyUnarchiveValues({ commit }, {search = null, start = 0, limit = 20} = {}) {
      commit('setCompanyUnarchiveValuesLoading', true)
      const data = {
				search,
        start,
        limit
      }
      const unarchive_values = await getCompanyUnarchiveValues(data)
      if (unarchive_values.code === 200) {
        commit('setCompanyUnarchiveValues', unarchive_values.unarchive_values)
        commit('setCompanyUnarchiveValuesCount', unarchive_values.unarchive_values_count)
      }
      commit('setCompanyUnarchiveValuesLoading', false)
    },
    async getUserCompanyConnectedStatus({ commit }, data) {
      commit('setLoadingUserCompanyConnectedStatus', true)
      const status = await getUserCompanyStatus(data)
      if (status.code === 200) {
        commit('setUserCompanyConnectedStatus', status.status)
      }
      commit('setLoadingUserCompanyConnectedStatus', false)
    },
    async updateUserCompanyConnectedStatus({ commit }, data) {
      commit('setLoadingUserCompanyConnectedStatus', true)
      const status = await updateUserCompanyStatus(data)
      if (status.code === 200) {
        commit('setUserCompanyConnectedStatus', status.status)
      }
      commit('setLoadingUserCompanyConnectedStatus', false)
    },
		async getCompanyPlanningStages({ commit }, companyId) {
			commit('setCompanyPlanningStagesLoading', true)
			const data = {
				company_id: companyId
			}
			const response = await getAllCompanyStages(data)
			if (response.code === 200) {
				commit('setCompanyPlanningStages', response.company_stages)
			}
			commit('setCompanyPlanningStagesLoading', false)
		},
		async getCompanyTemplates({ commit }, {type = null, start = 0, limit = 100} = {}) {
			commit('setLoadingCompanyDocumentTemplates', true)
			const data = {
				type,
				start,
				limit
			}
			const response = await getCompanyDocumentTemplates(data)
			if (response.code === 200) {
				commit('setCompanyDocumentTemplates', response.templates)
			}
			commit('setLoadingCompanyDocumentTemplates', false)
		}
  }
}

export default companyStore
